import { forwardRef, type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const paperVariants = cva("bfrs-rounded-xl bfrs-transition-shadow bfrs-duration-200", {
  variants: {
    variant: {
      default: "bfrs-faded-card-border bfrs-bg-surface-card bfrs-shadow-card",
      muted: "bfrs-border bfrs-border-border bfrs-bg-surface-muted",
      elevated: "bfrs-faded-card-border bfrs-bg-surface-card bfrs-shadow-elevated",
      outlined: "bfrs-border bfrs-border-border bfrs-bg-surface-card bfrs-shadow-none",
      glass: "bfrs-faded-card-border bfrs-bg-surface-card/80 bfrs-shadow-card bfrs-backdrop-blur-md"
    },
    padding: {
      none: "bfrs-p-0",
      sm: "bfrs-p-4",
      md: "bfrs-p-5",
      lg: "bfrs-p-6"
    }
  },
  compoundVariants: [{ variant: "outlined", padding: "md", className: "bfrs-px-[22px] bfrs-py-[18px]" }],
  defaultVariants: {
    variant: "default",
    padding: "md"
  }
});

export type PaperProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof paperVariants>;

export const Paper = forwardRef<HTMLDivElement, PaperProps>(({ className, variant, padding, ...props }, ref) => (
  <div ref={ref} className={cn(paperVariants({ variant, padding }), className)} {...props} />
));

Paper.displayName = "Paper";
